import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsTeam from 'graphql/fields/FieldsTeam'

const fields = {
	'guid': 'String!',
};

export default gql(`
	query team( ${ HelperGraphql.createFields( fields ) } ) {
		team( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsTeam}
		}
	}
`);

